import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import Text from '@jetbrains/ring-ui/components/text/text';
import { ConstituentDisabledWidget } from '@modules/constituents/widget/constituent-disabled-widget';
import { getConstituentDialogFirstStep } from '@modules/constituents/constituent-dialog/constituent-dialog-steps';
import { useModalsController } from '@common/modals/hooks';
import { assignTestId } from '@common/infra/tests/assign-test-id';
import { AiEnableDialog } from '../../../common/dialogs/ai-settings-dialog/ai-enable-dialog';
export function AiDisabledNoTrialWidget(props) {
    const { licenseType, constituentLicense } = props;
    const modalsController = useModalsController();
    const handleOpenModal = useCallback(async () => {
        const openEnableModal = modalsController.openModal(AiEnableDialog, {
            startFromStep: getConstituentDialogFirstStep(constituentLicense, licenseType)
        });
        openEnableModal.promise.then(() => {
            openEnableModal.closeModal();
        });
    }, [constituentLicense, licenseType, modalsController]);
    return (_jsx(ConstituentDisabledWidget, { ...props, ...assignTestId('widget-ai-enterprise'), onEnableClick: handleOpenModal, children: _jsx(Text, { children: "Empower your developers and enhance their productivity with AI Assistant. Your code will remain secure and your spending will stay completely in check." }) }));
}
